<div class="d-flex gap-4">
  <div class="radio-container">
    <app-radio-button-input
      [controlId]="'currentSpouse'"
      [ngModel]="spouseInfo"
      (ngModelChange)="spouseInfoChange.emit($event)"
      [value]="SpouseInformationEnum.Current"
      [name]="'spouse'" />
    <app-form-option-label [labelFor]="'currentSpouse'" i18n>Use current spouse</app-form-option-label>
  </div>
  <div class="radio-container">
    <app-radio-button-input
      [controlId]="'newSpouse'"
      [value]="SpouseInformationEnum.New"
      [ngModel]="spouseInfo"
      (ngModelChange)="spouseInfoChange.emit($event)"
      [name]="'spouse'" />
    <app-form-option-label [labelFor]="'newSpouse'" i18n>Add new spouse</app-form-option-label>
  </div>
</div>
